<template>
  <div>
    <Header title="我的报名申请"></Header>
    <div class="find_select" v-if="schoolCode == '10689'">
			<div class="sem-drop">
				<div @click="semPicker = true">
					<p>{{ this.skkctext }}</p>
					<i></i>
				</div>
			</div>
			<van-popup v-model="semPicker" position="bottom">
				<van-picker show-toolbar :columns="skkcOption" @cancel="semPicker = false" @confirm="semConfirm" :item-height="itemHeight" />
			</van-popup>
		</div>
    <NOdata v-if="this.changeList.length == 0" title="暂无报名信息~"></NOdata>
    <template v-else>
      <div  v-for="(item,index) in changeList" :key="index">
      <div class="grey-contain">
        <div>
          <p>{{item.examinationType}}({{item.examinationGrade}})</p>
          <span>截止时间：{{item.deadline}}</span><br>
          <span>考试时间：{{item.time}}</span>
        </div>
        <div :class="item.status == '通过' ? 'text2' : 'text1'">{{item.status}}</div>
      </div>
      <div  class="grey-cancelbut" v-if="schoolCode=='10488' &&item.isCanCancel=='1'"><button @click="cancelSign(item.examSingId)">取消报名</button></div>
    </div>
    </template>
  </div>
</template>

<script>
  import { Api } from '../../utils/axios'
  export default {
    data(){
      return{
        schoolCode:sessionStorage.getItem('schoolCode'),
        changeList:[],
        semPicker: false,
				itemHeight: 35,
				skkcOption: [],
				skkcval: '',
        skkctext: '',
        schoolCode:sessionStorage.getItem("schoolCode")
      }
    },
    methods:{
      async getList(){
        const param = {
          skkcid: this.skkcval
        }
        const res = await Api.getMyExamination(param)
        this.changeList = res.data
      },
      async getSkkc() {
				const res = await Api.findDictionry({ zzdtype: "skkc" });
				if (res.code == "1") {
					this.skkcOption = res.data.skkc.map((item, index) => {
            return {
              text: item.skkcmc,
              value: item.skkcid
            };
					})
				}
        this.skkcval = '';
        this.skkctext = '全部'
        this.skkcOption.unshift({text:'全部',value:''})
				this.getList()
			},
      semConfirm(e, val) {
				this.semPicker = false;
        this.skkctext = e.text;
				this.skkcval = e.value;
				this.getList()
			},
      async cancelSign(examSingId){
        const param = {
          signId: examSingId
        }
        const res = await Api.CancelGradeExamina(param)
        if(res.code=='1'){
          this.$toast.success("取消报名成功！");
          setTimeout(() => {
            this.getList()
        }, 500);
        }
      }
    },
    created(){
      if(this.schoolCode == '10689'){
				this.getSkkc();
			}else{
        this.getList()
      }
    },
  }
</script>

<style lang="less" scoped>
  .grey-contain>div:first-child{width: 80%;}
  .grey-contain p{font-weight: 600;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;}
  .grey-contain span{color: @attendance-color-2;font-size: 12px;}
  .grey-contain .text1{font-size: 14px;color: @attendance-background-color-13;font-weight: 600;}
  .grey-contain .text2{font-size: 14px;color: @attendance-background-color-12;font-weight: 600;}

  .find_select {
    display: flex;
    justify-content: center;
    align-items: center;
    border-bottom: 1px solid @attendance-border-color-6;
    padding: 20px 0 7px;
}
.find_select select {
    border: 0;
    background: 0;
    outline: 0;
}

.find_select .sem-drop {
    width: 80%;
}
.find_select .van-picker-column__item {
    margin: 0 30%;
}
.find_select .sem-drop > div {
    width: 45%;
}
.find_select .van-popup.van-popup--bottom {
    border-radius: 5px 5px 0 0;
}
.find_select .sem-drop p {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    text-align: right;
}
.find_select .sem-drop,
.find_select .sem-drop div {
    display: flex;
    align-items: center;
    color: @attendance-color-2;
    font-size: 14px;
    justify-content: center;
}
.find_select .sem-drop > div i {
    background: url(../../../static/img/Triangle.png) no-repeat center;
    width: 10px;
    height: 10px;
    background-size: 10px 8px;
    margin-left: 5px;
}
.find_select .van-ellipsis.van-picker-column__item.van-picker-column__item--selected {
    font-weight: 600;
    color: @attendance-color-1;
}

.find_select .van-picker__columns::before {
    width: 140px;
    height: 1px;
    background-color: @attendance-background-color-2;
    content: '';
    position: absolute;
    top: 70px;
    left: 50%;
    transform: translateX(-50%);
}
.find_select .van-picker__columns::after {
    width: 140px;
    height: 1px;
    background-color: @attendance-background-color-2;
    content: '';
    position: absolute;
    bottom: 70px;
    left: 50%;
    transform: translateX(-50%);
}
.grey-contain{
  border-bottom-right-radius: 0px;
  border-bottom-left-radius: 0px;
}
.grey-cancelbut{
  background-color: #F8F8F8;
  border-radius: 5px;
  border-top-right-radius: 0px;
  border-top-left-radius: 0px;
  margin-left: 20px;
  margin-right: 20px;
  text-align: right;
  padding-right: 20px;
  padding-bottom: 10px;
  button{
    background-color: @attendance-background-color-7;
    color: @attendance-background-color-1;
    padding: 11px 0;
    width: 80px;
    border-radius: 3px;
    height: 35px;
    line-height: 35px;
    font-size: 15px;
    padding-top: 0px;
    padding-bottom: 0px;
  }
}

.grey-cancelbut-span{
    width: 100px;
    height: 35px;
    line-height: 35px;
    font-size: 15px;
    background-color: #F8F8F8;
    border-radius: 10px;
    text-align: center;
    color: #7469F8;

  }

</style>



// WEBPACK FOOTER //
// src/components/student/myExam.vue